export default __webpack_public_path__ + "static/media/authentication-icon.3be423e9.svg";